import React, { FC } from 'react';
import Heading from 'components/Heading/Heading';
import greenWorldImg from 'images/green-world.png';
import { AnimateOnScroll } from '../../components/AnimationOnScroll/AnimationOnScroll';

export interface SectionPrioritizingSustainabilityProps {
  className?: string;
}

const SectionPrioritizingSustainability: FC<SectionPrioritizingSustainabilityProps> = ({
  className = ''
}) => {
  return (
    <div className={`nc-SectionPrioritizingSustainability relative ${className}`}>
      <div className="p-8 rounded-3xl max-w-5xl px-4 mx-auto">
        <Heading
          isCenter
          desc={'Our mobile units use just 4.5 liters of water per car'}
        >
          Prioritizing Sustainability
        </Heading>

        <div className="mt-8 flex flex-col lg:flex-row items-center gap-8">
          <div className="lg:w-1/2 flex justify-center">
            <AnimateOnScroll
              variants={{
                hidden: { opacity: 0, x: -50 },
                visible: {
                  opacity: 1,
                  x: 0,
                  transition: {
                    duration: 0.8,
                    ease: 'easeOut',
                  }
                }
              }}
            >
              <img
                src={greenWorldImg}
                alt="Eco-friendly car wash"
                className="rounded-2xl max-w-full h-auto filter drop-shadow-[0_0_70px_rgba(0,128,0,0.6)]"
              />
            </AnimateOnScroll>
          </div>

          <div className="lg:w-1/2 space-y-4">
            <AnimateOnScroll
              variants={{
                hidden: { opacity: 0, x: 50 },
                visible: {
                  opacity: 1,
                  x: 0,
                  transition: {
                    duration: 0.4,
                    ease: 'easeOut',
                    delay: 0.3
                  }
                }
              }}
            >
              <p className="text-base md:text-lg text-neutral-700 dark:text-neutral-300">
                Let's face it—traditional car washes waste a ton of water. At Schoon, we're changing that. Our mobile
                units use just 4.5 liters of water per car, compared to up to 450 liters at a regular wash. That's
                smarter for your car and the planet.
              </p>
            </AnimateOnScroll>
            <AnimateOnScroll
              variants={{
                hidden: { opacity: 0, x: 50 },
                visible: {
                  opacity: 1,
                  x: 0,
                  transition: {
                    duration: 0.4,
                    ease: 'easeOut',
                    delay: 0.5
                  }
                }
              }}
            >
              <p className="text-base md:text-lg text-neutral-700 dark:text-neutral-300">
                Plus, our Schoon vehicles can clean up to 60 cars on a single charge—no extra driving, no emissions,
                just efficient, eco-friendly service right where you're parked.
              </p>

            </AnimateOnScroll>

            <AnimateOnScroll
              variants={{
                hidden: { opacity: 0, x: 50 },
                visible: {
                  opacity: 1,
                  x: 0,
                  transition: {
                    duration: 0.4,
                    ease: 'easeOut',
                    delay: 0.7
                  }
                }
              }}
            >
              <p className="text-base md:text-lg text-neutral-700 dark:text-neutral-300 font-medium">
                Less water. Less waste. More clean. When you choose Schoon, you're making a simple, sustainable choice
                that actually makes a difference.
              </p>

            </AnimateOnScroll>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionPrioritizingSustainability;
